export function parseMMDDYYYYToDate(value) {
	if (!value) return null;
	if (value instanceof Date)
		return new Date(value.getFullYear(), value.getMonth(), value.getDate());
	if (typeof value !== 'string') return null;
	const parts = value.split('/');
	if (parts.length !== 3) return null;
	const mm = parseInt(parts[0], 10);
	const dd = parseInt(parts[1], 10);
	const yyyy = parseInt(parts[2], 10);
	const d = new Date(yyyy, mm - 1, dd);
	return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateToMMDDYYYY(d) {
	if (!d) return '';
	const mm = String(d.getMonth() + 1).padStart(2, '0');
	const dd = String(d.getDate()).padStart(2, '0');
	const yyyy = d.getFullYear();
	return `${mm}/${dd}/${yyyy}`;
}

// Minimal helpers: normalize a single value or an array to Date(s) at midnight.
export function normalizeDate(value, today) {
	if (!value) return null;
	if (value instanceof Date)
		return new Date(value.getFullYear(), value.getMonth(), value.getDate());
	if (typeof value === 'string') return parseMMDDYYYYToDate(value);
	if (typeof value === 'number' && today) {
		const base = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate(),
		);
		const tmp = new Date(base);
		tmp.setDate(tmp.getDate() + value);
		return new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate());
	}
	return null;
}

export function normalizeDates(arr) {
	if (!arr) return [];
	if (!Array.isArray(arr)) return [];
	// if items are already Date, normalize them; else try to parse strings
	if (arr.length > 0 && arr[0] instanceof Date) {
		return arr.map(
			(d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()),
		);
	}
	return arr.map((s) => parseMMDDYYYYToDate(s)).filter(Boolean);
}

export function formatDatePretty(value) {
	try {
		const parts = (`${  value}`).split('/').map((p) => parseInt(p, 10));
		if (parts.length !== 3) return 'Select a day...';
		const [mm, dd, yyyy] = parts;
		const d = new Date(yyyy, mm - 1, dd);
		const day = d.getDate();
		const month = d.toLocaleString('en-US', { month: 'long' });
		return `${month} ${day}, ${d.getFullYear()}`;
	} catch (e) {
		return 'Select a day...';
	}
}
